import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nessuna modifica rispetto alle fasce configurate nella "),
  /*#__PURE__*/_createElementVNode("strong", null, "zona")
], -1)
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = { class: "p-d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeShiftAutocomplete = _resolveComponent("TimeShiftAutocomplete")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TimeShiftAutocomplete, {
        ids: _ctx.selectedShiftsIds,
        onSelect: _ctx.onTimeShiftSelect
      }, null, 8, ["ids", "onSelect"])
    ]),
    (!_ctx.hasCustomShiftCosts)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: false
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          class: "p-mt-3",
          value: _ctx.tableShiftCosts
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: { minWidth: '180px' },
              frozen: "",
              header: "Fascia oraria"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", null, _toDisplayString(data.shift.start_time) + " - " + _toDisplayString(data.shift.end_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: { minWidth: '180px' },
              header: "Lunedì - Venerdì"
            }, {
              body: _withCtx(({data,index}) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_FloatLabel, {
                    label: "Costo",
                    labelClass: index%2 ? 'half-bg' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputNumber, {
                        modelValue: data.weekDay1?.hour_cost,
                        "onUpdate:modelValue": ($event: any) => (_ctx.onWeekDayCostChange(
                    [1,2,3,4,5], 
                    data,
                    $event
                  )),
                        mode: "currency",
                        currency: "EUR",
                        class: "small_input"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["labelClass"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: { minWidth: '180px' },
              header: "Sabato"
            }, {
              body: _withCtx(({data, index}) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_FloatLabel, {
                    label: "Costo",
                    labelClass: index%2 ? 'half-bg' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputNumber, {
                        modelValue: data.weekDay6?.hour_cost,
                        "onUpdate:modelValue": ($event: any) => (_ctx.onWeekDayCostChange(
                    [6],
                    data, 
                    $event
                  )),
                        mode: "currency",
                        currency: "EUR",
                        class: "small_input"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["labelClass"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: { minWidth: '180px' },
              header: "Domenica"
            }, {
              body: _withCtx(({data, index}) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_FloatLabel, {
                    label: "Costo",
                    labelClass: index%2 ? 'half-bg' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputNumber, {
                        modelValue: data.weekDay7?.hour_cost,
                        "onUpdate:modelValue": ($event: any) => (_ctx.onWeekDayCostChange(
                    [7],
                    data, 
                    $event
                  )),
                        mode: "currency",
                        currency: "EUR",
                        class: "small_input"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["labelClass"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { class: "column-header-right p-text-right" }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_DeleteButton, {
                  title: "Rimuovi fascia",
                  onClick: ($event: any) => (_ctx.removeShift(data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
  ]))
}